import { toast } from "sonner";
import { updateOpening } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { sales_coordinator, skills, ...rest } = values;

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        status: values.status,
    };

    if (sales_coordinator !== undefined && sales_coordinator !== null) {
        payload.sales_coordinator = typeof sales_coordinator === "object" ? sales_coordinator.id : sales_coordinator;
    }

    if (skills !== undefined) {
        payload.skills = Array.isArray(skills) ? skills.map(s => ({ skill: { id: typeof s === "object" ? s.id : s } })) : [];
    }

    return payload;
}

export function useUpdateOpening() {
    return useMutation({
        mutationFn: async ({ openingId, values }) => {
            const payload = buildPayload(values);

            try {
                const response = await updateOpening({ openingId, item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Opening Updated Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
